// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Unstarted/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_DentalMonitoring_Content_Unstarted_Content($id: uuid!, $quickstart_id: numeric!) {
  dental_monitoring_patient_monitoring_start(
    id: $id
    quickstart_id: $quickstart_id
  ) {
    id
    patient {
      monitoring {
        status
        config {
          protocol_title
        }
      }
    }
  }
}

`